define('Planspage.ei1.Main.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function PlanspageModel () {
        SCModel.call(this);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/PlansPage/SuiteScript2/Planspage.ei1.Main.Service.ss"
                ), true
            )
        }
    }
 
    PlanspageModel.prototype = Object.create(SCModel.prototype);
    PlanspageModel.prototype.constructor = PlanspageModel;
 
    return PlanspageModel
})
